<template>
  <div class="mobile-page-case">
    <!-- 头部 -->
    <div class="mobile-header-box">
      <div class="mobile-header-title" id="title1"></div>
      <div class="mobile-header-title" id="title2"></div>
    </div>
    <div v-for="(item, index) in imgData" :key="index">
      <!-- 内容部分 Top -->
      <SRF>
        <ContentTop
          :list="getImgList(index, 1)"
          :cate="item.cate"
          @toInfo="toInfo"
        />
      </SRF>
      <SRF>
        <ContentBottom
          :dataIndex="index"
          :list="getImgList(index, 3)"
          @toInfo="toInfo"
        />
      </SRF>
    </div>
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/MobileIframe/components/Footer";
import ContentTop from "./components/ContentTop";
import ContentBottom from "./components/ContentBottom";
import ContentSwiper from "./components/ContentSwiper";
import { pageApi } from "@/api";
import _ from "lodash";

export default {
  components: {
    Footer,
    ContentTop,
    ContentBottom,
    ContentSwiper,
  },
  data() {
    return {
      imgData: [],
    };
  },

  created() {
    // console.log(this.$publicData)
  },
  mounted() {
    this.getcaseList();
    this.initTyped();
  },
  computed: {
    getImgList() {
      return (index, type) => {
        // 检查下标是否越界
        if (!this.imgData[index] || !this.imgData[index].list) {
          return [];
        }
        switch (type) {
          case 1:
            return this.imgData[index].list.slice(0, 2);
          case 3:
            return this.imgData[index].list.slice(2);
          // return (
          //   _.chunk(
          //     JSON.parse(JSON.stringify(this.imgData[index].list)).slice(2)
          //   ) || []
          // );
        }
      };
    },
  },
  methods: {
    async getcaseList() {
      const res = await pageApi.getCaseList();
      this.imgData = res.result;
    },
    initTyped() {
      new this.Typed("#title1", {
        strings: ["作品是 <span>最佳证言</span>"],
        typeSpeed: 100,
      });

      new this.Typed("#title2", {
        strings: ["从设计到开发，见证实力沉淀的过程"],
        typeSpeed: 100,
      });
    },
    toInfo(id) {
      console.log(id, "toInfo");
      this.$router.push({ name: "phone-caseInfo", query: { id } });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile-page-case {
  width: 46.875rem;
  background: #0d0d0d;
}

.mobile-page-case .mobile-header-box {
  width: 30.1875rem;
  padding: 13.3125rem 12.9375rem 0 3.75rem;
  margin-bottom: 15.8125rem;
}

.mobile-page-case .mobile-header-box .mobile-header-title {
  width: 30.1875rem;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 2.625rem;
  color: #e3b281;
  line-height: 3.75rem;
}

.mobile-page-case .mobile-header-box .mobile-header-title span {
  font-weight: bold;
}
</style>
